// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__Fn2cq","top-left":"Logo_top-left__g8o9u","top-right":"Logo_top-right__CQlQO","bottom-left":"Logo_bottom-left__5FAoJ","bottom-right":"Logo_bottom-right__3c6YU"};